import * as React from 'react';
const SvgArrowLeft = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>

        <g>
            <path
                fill='currentColor'
                d='m6.322 10.542 2.035 2.035q.165.165.173.383a.51.51 0 0 1-.163.39.55.55 0 0 1-.393.17.55.55 0 0 1-.383-.177l-2.878-2.878a.62.62 0 0 1-.205-.461q0-.264.205-.469l2.878-2.878a.55.55 0 0 1 .38-.173.54.54 0 0 1 .396.165q.171.172.167.387a.55.55 0 0 1-.177.387L6.322 9.458h8.887a.53.53 0 0 1 .543.537.53.53 0 0 1-.156.388.52.52 0 0 1-.387.159z'
            />
        </g>
    </svg>
);
export default SvgArrowLeft;
